import axios from "axios";
import { BASE_URL_API } from "./Constants";

const attachmentInstance = axios.create({
  baseURL: `${BASE_URL_API}/api`,
  headers: {
    "Content-Type": "application/json",
  },
});

const attachmentMobileApisInstance = axios.create({
  baseURL: `${BASE_URL_API}/mobileapis`,
  headers: {
    "Content-Type": "application/json",
  },
});

// get workout attachment
async function getWorkoutAttachments(id) {
  try {
    let AUTH_TOKEN = window.localStorage.getItem("token");
    var config = {
      method: "get",
      url: `/get-workout-attachments?workout_id=${id}`,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + AUTH_TOKEN,
      },
      data: "",
    };

    return await attachmentInstance(config)
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        return error.response;
      });
  } catch (err) {
    return err;
  }
}

// add workout attachmenet
async function addWokroutAttachment(data) {
  try {
    let AUTH_TOKEN = window.localStorage.getItem("token");
    var config = {
      method: "post",
      url: `/add-workout-attachment`,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + AUTH_TOKEN,
      },
      data: data,
    };

    return await attachmentInstance(config)
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        return error.response;
      });
  } catch (err) {
    return err;
  }
}

// update workout attachmenet
async function updateWokroutAttachment(data) {
  try {
    let AUTH_TOKEN = window.localStorage.getItem("token");
    var config = {
      method: "post",
      url: `/update-workout-attachment`,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + AUTH_TOKEN,
      },
      data: data,
    };

    return await attachmentInstance(config)
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        return error.response;
      });
  } catch (err) {
    return err;
  }
}

// delete workout attachmenet
async function deleteWokroutAttachment(data) {
  try {
    let AUTH_TOKEN = window.localStorage.getItem("token");
    var config = {
      method: "delete",
      url: `/delete-workout-attachment?${data}`,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + AUTH_TOKEN,
      },
      data: "",
    };

    return await attachmentInstance(config)
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        return error.response;
      });
  } catch (err) {
    return err;
  }
}

// get program attachment
async function getProgramAttachments(id) {
  try {
    let AUTH_TOKEN = window.localStorage.getItem("token");
    var config = {
      method: "get",
      url: `/get-program-attachments?program_id=${id}`,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + AUTH_TOKEN,
      },
      data: "",
    };

    return await attachmentInstance(config)
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        return error.response;
      });
  } catch (err) {
    return err;
  }
}

// add program attachmenet
async function addProgramAttachment(data) {
  try {
    let AUTH_TOKEN = window.localStorage.getItem("token");
    var config = {
      method: "post",
      url: `/add-program-attachment`,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + AUTH_TOKEN,
      },
      data: data,
    };

    return await attachmentInstance(config)
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        return error.response;
      });
  } catch (err) {
    return err;
  }
}

// update program attachmenet
async function updateProgramAttachment(data) {
  try {
    let AUTH_TOKEN = window.localStorage.getItem("token");
    var config = {
      method: "post",
      url: `/update-program-attachment`,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + AUTH_TOKEN,
      },
      data: data,
    };

    return await attachmentInstance(config)
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        return error.response;
      });
  } catch (err) {
    return err;
  }
}

// delete program attachmenet
async function deleteProgramAttachment(data) {
  try {
    let AUTH_TOKEN = window.localStorage.getItem("token");
    var config = {
      method: "delete",
      url: `/delete-program-attachment?${data}`,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + AUTH_TOKEN,
      },
      data: "",
    };

    return await attachmentInstance(config)
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        return error.response;
      });
  } catch (err) {
    return err;
  }
}


async function getGCFileUploadLink(data) {
  try {
    let AUTH_TOKEN = window.localStorage.getItem("token");
    var config = {
      method: "post",
      url: `/get-gcs-upload-link`,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + AUTH_TOKEN,
      },
      data: data,
    };

    return await attachmentMobileApisInstance(config)
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        return error.response;
      });
  } catch (err) {
    return err;
  }
}

const AttachmentServices = {
  getWorkoutAttachments,
  addWokroutAttachment,
  updateWokroutAttachment,
  deleteWokroutAttachment,

  getProgramAttachments,
  addProgramAttachment,
  updateProgramAttachment,
  deleteProgramAttachment,
  getGCFileUploadLink

};

export default AttachmentServices;
